export default "__VITE_ASSET__9265bd38__"